import {  RouteRecordRaw } from "vue-router";
import { userMustBeLoggedIn } from "../../router/guards";

const routes: RouteRecordRaw[] = [
    {
        name: 'settings',
        path: '/settings',
        component: () => import('./settings-page.vue'),
        beforeEnter: [userMustBeLoggedIn]
    }
]

export default routes;